var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6803_23241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 13C18.1 13 19 12.1 19 11C19 9.9 18.1 9 17 9C15.9 9 15 9.9 15 11C15 12.1 15.9 13 17 13ZM17 15C15.9 15 15 15.9 15 17C15 18.1 15.9 19 17 19C18.1 19 19 18.1 19 17C19 15.9 18.1 15 17 15ZM17 21C15.9 21 15 21.9 15 23C15 24.1 15.9 25 17 25C18.1 25 19 24.1 19 23C19 21.9 18.1 21 17 21Z",
    fill: "url(#paint0_linear_6803_23241)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6803_23241",
    x1: 15,
    y1: 9,
    x2: 19.5162,
    y2: 9.14706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FCF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ECA8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6803_23241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "transparent",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall);
export default __webpack_public_path__ + "static/media/small.4dcb381ed8d64bb0ddc2fa4132944f85.svg";
export { ForwardRef as ReactComponent };